import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { IRequestNote } from '../models/RequestNote';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';

const LIMIT = 10;

export default class RequestNoteStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.page = 0;
                this.RequestNoteRegistry.clear();
            }
        )
    }

    RequestNoteRegistry = new Map();
    RequestNote: IRequestNote | null = null;
    loadingInitial = false;
    submitting = false;
    target = "";
    requestNoteCount = 0;
    page = 0;
    predicate = new Map();

    setPredicate = (predicate: string, value: string | Date) => {
        this.predicate.clear();
        if (predicate !== 'My Notes') {
            this.predicate.set(predicate, value);
        } else {
            this.predicate.set('createdById', this.rootStore.userStore.user?.id)
        }
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('limit', String(LIMIT));
        params.append('offset', `${this.page ? this.page * LIMIT : 0}`);
        this.predicate.forEach((value, key) => {
            if (key === 'dateCreated') {
                params.append(key, value.toDateString());
            } else {
                params.append(key, value);
            }
        })
        return params;
    }

    get totalPages() {
        return Math.ceil(this.requestNoteCount / LIMIT);
    }

    setPage = (page: number) => {
        this.page = page;
    }

    get requestNotesById() {
        return this.groupRequestNotesById(Array.from(this.RequestNoteRegistry.values()));
    };

    groupRequestNotesById(requestNotes: IRequestNote[]) {
        const sortedRequests = requestNotes.sort(
            (a, b) => parseInt(b.id) - parseInt(a.id)
        )

        return Object.entries(sortedRequests.reduce((requestNotes, requestNote) => {
            const id = requestNote.id;
            requestNotes[id] = requestNotes[id] ? [...requestNotes[id], requestNote] : [requestNote];
            return requestNotes;
        }, {} as { [key: string]: IRequestNote[] }));
    }

    get requestNotesByDate() {
        return Array.from(this.RequestNoteRegistry.values()).sort(
            (a, b) => b.dateCreated - a.dateCreated
        );
    };

    loadRequestNotes = async (requestId: string | undefined) => {
        this.loadingInitial = true;
        try {
            const requestNotesEnvelope = await agent.RequestNotes.list(requestId);
            const { requestNotesDto, requestNoteCount } = requestNotesEnvelope;

            runInAction('loadRequestNotes', () => {
                requestNotesDto.forEach((requestNote) => {
                    this.RequestNoteRegistry.set(requestNote.id, requestNote);
                });
                this.requestNoteCount = requestNoteCount;
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadRequestNotes', () => {
            this.loadingInitial = false;
        });
    };

    loadRequestNote = async (id: string) => {
        let RequestNote = this.getRequestNote(id);
        if (RequestNote) {
            this.RequestNote = RequestNote;
            return RequestNote;
        }
        else {
            this.loadingInitial = true;
            try {
                RequestNote = await agent.RequestNotes.details(id);
                runInAction('getting activity', () => {
                    this.RequestNote = RequestNote;
                    this.RequestNoteRegistry.set(RequestNote.id, RequestNote);
                    this.loadingInitial = false;
                })
                return RequestNote;
            } catch (error) {
                toast.error('problem submitting data');
            }
        }
        runInAction('loadRequestNotes', () => {
            this.loadingInitial = false;
        });
    };

    getRequestNote = (id: string) => {
        return this.RequestNoteRegistry.get(id);
    }

    ClearRequestNote = () => {
        this.RequestNote = null;
    }

    createRequestNote = async (requestNote: IRequestNote) => {
        this.submitting = true;
        try {
            await agent.RequestNotes.create(requestNote);
            runInAction('create RequestNote', () => {
                this.submitting = false;
            });
            toast.success('Saved');
            this.rootStore.requestStore.incrementRequestNote(requestNote.requestId);
            this.rootStore.modalStore.closeModal();
        } catch (error) {
            runInAction('create RequestNote error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    deleteRequestNote = async (requestNoteId: string) => {
        this.submitting = true;
        try {
            await agent.RequestNotes.delete(requestNoteId);


            runInAction('delete RequestNote', () => {
                this.submitting = false;
                this.RequestNoteRegistry.delete(requestNoteId);
            });
            toast.success('Saved');

        } catch (error) {
            runInAction('delete RequestNote error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    editRequestNote = async (requestNote: IRequestNote) => {
    };



}
decorate(RequestNoteStore, {
    RequestNoteRegistry: observable,
    RequestNote: observable,
    loadingInitial: observable,
    submitting: observable,
    target: observable,
    requestNoteCount: observable,
    page: observable,
    predicate: observable,

    loadRequestNote: action,
    loadRequestNotes: action,
    ClearRequestNote: action,
    setPredicate: action,
    setPage: action,
    createRequestNote: action,
    editRequestNote: action,

    requestNotesById: computed,
    requestNotesByDate: computed,
    axiosParams: computed,
    totalPages: computed
});